// extracted by mini-css-extract-plugin
export default {"wrapper":"Interesting_wrapper__eS0U4","title":"Interesting_title__xuBhK","wrap":"Interesting_wrap__Dpwrt","card":"Interesting_card__gks7q","btns":"Interesting_btns__hWJ1f"};